/**
 * Using the Angular email directive for validation is not enough, as it allows addresses without
 * top level domain (e.g. "some@example"). Because our users often forget to write the TLD, we
 * add a separate validation here that checks if the email contains at least a dot and two further characters
 * somewhere after the @ sign.
 */
export const EMAIL_VALIDATION_REGEX = /^[a-zA-Z0-9._\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
